import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const MasterService = {
    getCountryByProjectID,
    getStateByCountryID,
    getBlockByStateID,
    getLocationByBlockID,
    getWellInfoByLocationID,
    getActivityOperationMaster,
    getActivityOperationMasterByName
}

async function getCountryByProjectID(projectId) {
    try {
        const response = await RestMethod.GET('configuration/' + projectId + '/master/country?filter[status]=1');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getStateByCountryID(projectId, countryId) {
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/master/state/country/' + countryId + "?filter[status]=1");
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
async function getBlockByStateID(projectId, stateId) {
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/master/block/state/' + stateId + "?filter[status]=1");
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getLocationByBlockID(projectId, blockId, filter) {
    let filterKey = filter ? filter : ""
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/master/location/block/' + blockId + "?filter[status]=1" + filterKey);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getWellInfoByLocationID(projectId, locationId, filter) {
    let filterdat = filter ? filter : ""
    try {
        const response = await RestMethod.GET('/configuration/' + projectId + '/master/wellInfo/location/' + locationId + "?filter[status]=1" + filterdat);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getActivityOperationMaster(projectId) {
    try {
        const response = await RestMethod.GET('configuration/' + projectId + '/master/activityOperationMaster' + "?filter[status]=1");
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getActivityOperationMasterByName(projectId, Name) {
    try {
        const response = await RestMethod.GET('configuration/' + projectId + '/master/sub-activity/' + Name);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
